<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Сбор отзывов и рейтингов</h4>
            <div class="sub-title">Сбор данных по ссылкам с экспортом в Excel</div>

          </div>
        </div>

        <div class="end-area">

        </div>
      </div>
<!--      <TopBlock></TopBlock>-->
    </div>
    <template v-if="parser.id">
      <template v-if="!parser.is_ready">
        <ParserStatus :parser="parser"></ParserStatus>


      </template>
      <template v-else>
        <ParserResult :parser="parser"></ParserResult>

        <div class="parser-end">
          <a :href="parser.report" class="btn btn-primary"><i class="bi bi-download"></i> Скачать Excel</a>
          <button class="btn btn-secondary" @click="setEmptyParser"><i class="bi bi-plus"></i> Начать новый сбор
          </button>
        </div>
      </template>
    </template>

    <template v-else>


      <h6><b>Выберите тип сбора данных</b>     <span class="text-muted small mb-3">
          <i class="bi bi-info-circle"></i>
          Быстрый сбор работает независимо от проектов. Результаты не сохраняются в проекты и не влияют на их данные.
        </span></h6>
      <div class="parser-type" id="parser_type">
        <a :class="'card p-3' + ((parser.types.indexOf('review')+1)?' active':'')"
           @click.prevent="addType('review')">
          <div class="title">
            <div class="ico"><i class="bi bi-chat-square-text"></i></div>
            <div class="wrap">
              <b>Сбор отзывов</b>
              <div class="sub-title">Все отзывы за период с текстом</div>
            </div>
            <div class="checkbox"></div>
          </div>
          <ul class="list">
            <li><i class="bi bi-check"></i> Текст отзыва</li>
            <li><i class="bi bi-check"></i> Дата</li>
            <li><i class="bi bi-check"></i> Оценка</li>
            <li><i class="bi bi-check"></i> Ответы компании</li>
          </ul>
        </a>
        <a :class="'card p-3' + ((parser.types.indexOf('rating')+1)?' active':'')"
           @click.prevent="addType('rating')">
          <div class="title">
            <div class="ico purple"><i class="bi bi-star"></i></div>
            <div class="wrap">
              <b>Сбор оценок и количества отзывов</b>
              <div class="sub-title">Только оценка и количество отзывов</div>
            </div>
            <div class="checkbox"></div>
          </div>
          <ul class="list">
            <li><i class="bi bi-check"></i> Средняя оценка</li>
            <li><i class="bi bi-check"></i> Количество отзывов</li>
            <li><i class="bi bi-check"></i> Быстрая обработка</li>
            <li><i class="bi bi-check"></i> Компактный отчёт</li>
          </ul>
        </a>
      </div>

      <div class="card p-3">
        <div class="title">
          <div>
            <b>Период сбора данных</b>
          </div>
        </div>
        <div class="help-text">Дата начала</div>
        <date-picker v-model="parser.date_from"
                     locale="ru"
                     :clearable="false"
                     format="dd.MM.yyyy"
                     model-type="yyyy-MM-dd"
                     :allowed-dates="allowedDates"
                     auto-apply
                     :enable-time-picker="false"></date-picker>
        <div class="help-text">По умолчанию сегодня и неделя назад</div>
      </div>

      <div class="card p-3 links" id="parser_links">
        <div class="title">
          <div>
            <b>Добавление ссылок</b>
          </div>
        </div>
        <ul class="nav nav-underline">
          <li class="nav-item">
            <a :class="'nav-link'+(link_tab==='handly'?' active':'')" @click="link_tab='handly'" aria-current="page"
               href="#">Вручную</a>
          </li>
          <li class="nav-item">
            <a :class="'nav-link'+(link_tab==='excel'?' active':'')" @click="link_tab='excel'" href="#">Загрузить
              Excel</a>
          </li>
          <li class="nav-item">
            <a :class="'nav-link'+(link_tab==='saved'?' active':'')" @click="link_tab='saved'" href="#">Из
              сохранённых</a>
          </li>
        </ul>
        <div :class="'tab'+(text_link_error?' error':'')" v-if="link_tab==='handly'">
          <span class="alert">Ошибка в вводе ссылок</span>
          <textarea class="form-control" v-model="text_link" placeholder="Вставьте ссылки каждая с новой строки

Например:
https://otzovil.com/reviews/kompaniya/
https://dreamjib.ru/employers/3235323/city
https://www.rustore.ru/catelog/app/app-name
"></textarea>

        </div>
        <div class="tab" v-if="link_tab==='excel'">
          <label :class="'drop-area' + (load_process?' loader':'')" for="load_links">
            <i class="bi bi-cloud-upload"></i>
            <h5>Перетащите файл сюда</h5>
            <span class="help-text">Или</span>
            <button class="btn btn-primary" @click="clickLoad">Выбрать файл</button>
            <span class="help-text">Формат xlsx первый столбец ссылка</span>
            <input type="file" id="load_links" ref="links_file"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="loadFile">
          </label>

        </div>
        <div class="tab" v-if="link_tab==='saved'">
          <div class="links-list">
            <ul>
              <li v-for="link in links">
                <a @click.prevent="addLink(link.link)"
                   :class="'link' + ((parser.links.indexOf(link.link)+1)?' active':'')" href="">
                  <div class="check">
                    <i class="bi bi-check2"></i>
                  </div>
                  <div>
                    <b>{{ link.link }}</b>
                    <div class="help-text" v-if="link.group">Группа: {{ link.group.name }}</div>
                  </div>
                </a>
              </li>
            </ul>
            <a href="" @click.prevent="addAllLinks" class="line text-primary float-end">Выбрать все</a>
          </div>

        </div>
        <div class="line">
          <p>Ссылок добавлено: <b>{{ parser.links.length }}</b></p>
          <a href="">Очистить</a>
        </div>
      </div>

      <div class="status">
        <i class="bi bi-info-circle text-primary"></i>
        <div class="steps">
          <b> Готовность к запуску: </b>
          <ul class="list-unstyled">
            <li v-if="parser.types.length" class="text-success"><i class="bi bi-check"></i> Режим сбора выбран: <span
                v-for="type in parser.types">{{ type_names[type] }}&nbsp;</span></li>
            <li v-else class="text-danger"><i class="bi bi-check"></i> Режим сбора не выбран</li>
            <li v-if="parser.date_from" class="text-success"><i class="bi bi-check"></i> Период указан:
              {{ $moment(parser.date_from).format("DD.MM.YYYY") }}- {{ $moment().format("DD.MM.YYYY") }}
            </li>
            <li v-else class="text-danger"><i class="bi bi-check"></i> Период сбора не указан</li>
            <li v-if="parser.links.length" class="text-success"><i class="bi bi-check"></i> Ссылок загружено:
              {{ parser.links.length }}
            </li>
            <li v-else class="text-danger"><i class="bi bi-check"></i> Добавьте хотя бы одну ссылку</li>
          </ul>
        </div>
        <div class="buttons">
          <button class="btn btn-secondary">Сбросить</button>
          <button class="btn btn-primary" @click="startParser">Запустить парсинг</button>
        </div>

      </div>
    </template>

    <modal modal_id="load_link_result">
      <template v-slot:header>
        <h4>Результаты загрузки</h4>
      </template>
      <template v-slot:body>
        <div v-if="save_answer.length">
          <template v-for="error in save_answer">
            <p v-html="error"></p>
          </template>
        </div>


      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'load_link_result')"
                data-bs-dismiss="modal">Закрыть
        </button>
      </template>
    </modal>

  </div>


</template>

<script>


import TopBlock from "@/components/TopBlock.vue";
import moment from "moment";
import {ParserApi} from "@/api/parser";
import {LinksApi} from "@/api/links";
import ParserStatus from "@/views/dictionary/review/components/ParserStatus.vue";
import ParserResult from "@/views/dictionary/review/components/ParserResult.vue";

export default {
  name: 'ParserProcess',
  data() {
    return {
      text_link: "",
      text_link_error: false,
      load_process: false,
      links: [],
      resources: [],
      parser: {
        types: [],
        date_from: moment().subtract(7, 'day').format("YYYY-MM-DD"),
        links: []
      },
      load_links: {
        text: [],
        file: [],
        selected: []
      },
      save_answer: [],
      link_tab: "handly",
      type_names: {
        review: "Сбор отзывов",
        rating: "Сбор оценок"
      }

    }
  },
  components: {ParserResult, TopBlock, ParserStatus},
  watch: {
    link_tab() {
      this.text_link_error = false;
    },
    text_link(value) {
      let links = value.split('\n').map(x => x.trim());
      let valid_links = links.filter(link => this.isValidHttpUrl(link))
      this.text_link_error = links.length !== valid_links.length
      this.parser.links = links;
    }
  },
  computed: {
    allowedDates() {
      const today = new Date();
      const daysCount = this.$store.getters.tariff?.max_period_one;
      if (daysCount) {
        return [...Array(daysCount + 1)].map((_, index) => {
          const date = new Date(today);
          date.setDate(today.getDate() - index);

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');

          return `${year}-${month}-${day}`;
        })
      }
      return []
    },

    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },
  mounted: function () {
    LinksApi.review_domain_list().then(r => this.resources = r.map(x => x.domain))

    ParserApi.get().then(response => {
      if (response.results.length) {
        this.parser = Object.assign({}, this.parser, response.results[0]);
        this.startWatch()
      }
      // if (this.$store.getters.currentProject.user_id !== this.$store.getters.user.id) location.pathname = '/'
      if (!this.$store.getters.tariff.history_parser) location.pathname = '/'
    })
    LinksApi.get_list(1, 1000).then(response => {
      this.links = response.results;
    });
  },
  methods: {
    validateLink(link) {
      // if (this.isValidHttpUrl(link)){
      //  Добавить валидацию по resource определить домен базовый, ласт часть плюс зона
      // }
      return false;
    },
    // checkLinks(){
    //   let valid_links = [];
    //   let invalid_links = [];
    //   this.links.forEach(link=>{
    //     let valid = this.validateLink(link)
    //     if (valid) valid_links.push(link)
    //     else invalid_links.push(link)
    //   })
    //
    // },
    setEmptyParser() {
      this.parser = {
        types: [],
        date_from: moment().subtract(7, 'day').format("YYYY-MM-DD"),
        links: []
      }
    },
    loadFile() {
      this.load_process = true
      let formData = new FormData();
      if (this.$refs.links_file?.files) {
        formData.set('file', this.$refs.links_file?.files[0]);

        ParserApi.preload_file(formData).then(response => {
          this.save_answer = response.answer;
          this.$modal("show", "load_link_result")
          this.load_process = false;
          this.parser.links = response.links
        })
      }
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    startParser() {
      if (!this.parser.types.length) {
        const element = document.getElementById("parser_type")
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        this.$notify({
          type: 'error',
          title: 'Ошибка',
          text: 'Выберите тип сбора'
        });
      } else if (!this.parser.links.length) {
        const element = document.getElementById("parser_links")
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        this.$notify({
          type: 'error',
          title: 'Ошибка',
          text: 'Загрузите ссылки'
        });

      } else if (this.text_link_error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка',
          text: 'В ссылках присутствует ошибка'
        });
      } else {
        ParserApi.start_parser(this.parser).then(response => {
          this.parser = response
          this.$notify({
            type: 'success',
            title: 'Успешно',
            text: 'Процесс сбора начат'
          });
          this.startWatch()
        })
      }
    },
    addType(type_name) {
      let index = this.parser.types.findIndex(x => x === type_name);
      if (index >= 0) this.parser.types.splice(index, 1)
      else this.parser.types.push(type_name)
    },
    addLink(link) {
      let index = this.parser.links.findIndex(x => x === link);
      if (index >= 0) this.parser.links.splice(index, 1)
      else this.parser.links.push(link)
    },
    addAllLinks() {
      this.links.forEach(link => {
        if (this.parser.links.indexOf(link.link) < 0) {
          this.parser.links.push(link.link)
        }
      })
    },
    clickLoad() {
      document.getElementById('load_links').click()
    },
    stopTimer() {
      clearTimeout(this.timer)
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.getStatus()
      }, 10000)
    },
    startWatch() {
      if (!this.parser.is_ready) this.startTimer();
    },
    getStatus() {
      ParserApi.get_parser(this.parser.id).then(response => {
        this.parser = Object.assign({}, this.parser, response);
        if (this.parser.is_ready) this.stopTimer()
      })
    }
  }
}

</script>
<style scoped lang="scss">
.parser-type {
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  gap: 30px;

  .card {
    height: 200px;
    flex: 1 1 auto;

    &:hover {
      text-decoration: none;
      cursor: pointer;
    }

    &.active {
      border: 1px solid var(--primary) !important;
      background: var(--soft-blue);

      .checkbox:after {
        content: "";
        height: 14px;
        width: 14px;
        background: var(--primary);
        border-radius: 5px;
        left: 2px;
        position: absolute;
        top: 2px;
      }
    }

    ul {
      list-style: none;
      color: var(--grey);

      li {
        margin-bottom: 7px;
      }

      i {
        color: var(--green)
      }
    }

    .title {
      align-items: center;
      gap: 10px;

      .ico {
        width: 40px;
        height: 40px;
        border-radius: 5px;
        background: var(--light-blue);
        color: var(--primary);
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.purple {
          background: var(--soft-purple);
          color: var(--purple);
        }
      }

      .checkbox {
        margin-left: auto;
        height: 20px;
        width: 20px;
        border: 1px solid var(--primary);
        border-radius: 5px;
      }
    }
  }
}

.parser-end {
  display: flex;
  justify-content: center;
  gap: 30px;

  button, a {
    width: 200px;
    height: 40px;
  }
}

.links {
  .tab {
    &.error {
      .alert {
        display: block;
        color: var(--red);
      }

      textarea {
        border: 1px solid var(--red);

        &:focus {
          box-shadow: 0 0 0 0.25rem rgba(224, 65, 65, 0.25);
        }
      }
    }

    .links-list {
      ul {
        height: 310px;
        overflow-y: auto;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .link {
          display: flex;
          gap: 20px;
          align-items: start;
          color: var(--dark-grey);

          &.active {
            .check {
              border-color: var(--primary);
              background: var(--primary);
              color: var(--white);

              i {
                display: block;
              }
            }
          }

          &:hover {
            text-decoration: none;
          }

          .check {
            border-radius: 5px;
            height: 20px;
            width: 20px;
            border: 1px solid var(--grey);
            margin-top: 2px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              display: none;
              font-weight: bold;
            }
          }

        }
      }
    }

    .alert {
      display: none;
    }

    .drop-area {
      position: relative;

      &.loader {
        &:before {
          content: "";
          background: rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(10px);
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
        }

        &:after {
          animation: changeContent .8s linear infinite;
          display: block;
          content: "⠋";
          font-size: 70px;
          color: var(--primary);
          z-index: 1;
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
        }

      }

      border: 2px dashed var(--soft-grey);
      border-radius: 5px;
      overflow: hidden;
      padding: 45px;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 13px;

      i {
        font-size: 40px;
        color: var(--grey);
      }

      input {

        position: absolute;
        left: -1000px;
      }
    }
  }

  textarea {
    height: 315px;
  }

  .line {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;

    a {
      color: var(--primary);
      font-weight: bold;
    }
  }

}

.process {
  color: #fff;
  background-image: linear-gradient(to right bottom, #3b81f6, #347af4, #2e72f1, #296bee, #2563eb);
}

.status {
  display: flex;
  justify-content: start;
  align-items: start;
  gap: 20px;

  .steps {
    font-size: 12px;
  }

  .buttons {
    margin-left: auto;
    display: flex;
    gap: 10px;
  }
}

@media (width < 768px) {
  .parser-end {
    button, a {
      width: 200px;
      height: 50px;
      display: flex;
      gap: 5px;
      justify-content: space-around;
    }
  }
  .parser-type{
    flex-wrap: wrap;
    gap: 0;
  }

}
</style>
